import { render, staticRenderFns } from "./MypageSelectPlanButtonParts.vue?vue&type=template&id=a0854ac0&scoped=true"
import script from "./MypageSelectPlanButtonParts.vue?vue&type=script&lang=ts"
export * from "./MypageSelectPlanButtonParts.vue?vue&type=script&lang=ts"
import style0 from "./MypageSelectPlanButtonParts.vue?vue&type=style&index=0&id=a0854ac0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0854ac0",
  null
  
)

export default component.exports